<!-- @format -->

<route-base>
  <style>
    a {
      cursor: pointer;
    }
  </style>

  <toasts di-register-name="toast" lifespan="5000"></toasts>
  <loading di-register-name="loader"></loading>

  <div class="container_contents">
    <router>
      <route
        each="{ page in pages }"
        path="{ page.route }"
        data-is="{ page.is }"
      >
        <div is="{ page.is }" route-params="{ route.params }"></div>
      </route>
    </router>
  </div>

  <footer-tag></footer-tag>

  <script>
    import di from "dependeny-injection";
    import { Router, Route, router } from "@riotjs/route";
    //import headerTag from "@tags/parts/header-tag.riot";
    //import footerTag from "@tags/parts/footer-tag.riot";
    import loading from "@tags/parts/loading.riot";
    import toasts from "@tags/parts/toasts.riot";
    import routes from "@model/register-routes.js";

    di.set("router", router);

    export default {
      pages: routes.pages,
      components: {
        Router,
        Route,
        //"header-tag": headerTag,
        //"footer-tag": footerTag,
        loading,
        toasts,
        ...routes.pages.reduce((acc, cur) => {
          acc[cur.is] = cur.component;
          return acc;
        }, {}),
      },
      onMounted() {
        // ルートイベント

        router.on.value((path) => {
          // analytics
          if (!path.match(/^http/)) {
            window.analytics.event("page_view", {
              page_path: location.href.substr(location.origin.length),
            });
          }
          if (!path.match(/^http/)) {
            if (routes.pages.find((v) => v.route.exec(path))) {
              // ルートがある場合
            } else {
              // ルートがない場合はページ遷移
              location.href = path;
            }
          }
        });
      },
    };
  </script>
</route-base>
